var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverDiningOrderModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#df1e5b",
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#df1e5b",
    stroke: "#df1e5b",
    strokeWidth: 0.1,
    d: "M47.57 25.038h0v-.002c.685-.84.636-2.078-.146-2.86-.834-.835-2.188-.835-3.022 0l.035.035-.035-.035-17.62 17.62-7.184-7.185h0l-.002-.002-.158-.143h0l-.002-.002c-.84-.685-2.078-.636-2.86.147-.835.834-.835 2.187 0 3.022l8.696 8.695h0l.001.002.159.144h0l.002.001c.84.685 2.077.636 2.86-.147l19.13-19.13h0l.002-.002.143-.158z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverDiningOrderModalIcon);
export default __webpack_public_path__ + "static/media/deliver-dining-order-modal-icon.be41249f455aa70b25ce279dc2bec727.svg";
export { ForwardRef as ReactComponent };